import styled from 'styled-components';
import {
  TextArea as SemanticTextArea,
  Form as SemanticForm,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  max-height: 100%;
  overflow-y: auto;
  width: 100%;
  word-wrap: break-word;
`;

export const Instructions = styled.div`
`;

export const FieldValue = styled(TextLayoutComponent)`
  word-wrap: break-word;
`;

export const Form = styled(SemanticForm)``;

export const TextArea = styled(SemanticTextArea)`
  &&&{
    margin: 10px 0 15px;
  }
`;
